import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-fracaso',
  templateUrl: './fracaso.component.html',
  styleUrls: ['./fracaso.component.css']
})
export class FracasoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
